<ngx-ui-loader [loaderId]="id" *ngIf="this.id"></ngx-ui-loader>
